<template>
	<ul class="tree-group">

		<nk-virtual-scroller :height="localHeight" :lazy-id="parentId ? 'a' + parentId : `godFather${randomId}`" :key="localHeight" :items="visibleNodes">
			<template v-slot:li="{ item }">
				<li :key="item.id + expands.includes(item.id) ? 'expanded' : 'collapsed'" :class="item.cssClass" :data-key="item.id">
					<div class="node-line"></div>
					<div class="row no-gutters tree-group-item" @click="onNodeClick(item)" @dblclick="onNodeDblClick(item)" v-on:selected="onNodeClick(item)">
						<div class="col-auto px-0 node-ver-line"></div>
						<div class="col-auto px-0 node-icon" @click="e => onNodeStateChangeClicked(e, item)">
							<div class="icon">
								<icon icon="plus" v-if="(item.hasChild) && !expands.includes(item.id)" class="expand-icon" />
								<icon :icon="['fas', 'minus']" v-else-if="(item.hasChild) && expands.includes(item.id)" class="fa fa-minus expand-icon" />
								<i v-else class="expand-icon"></i>
							</div>
						</div>
						<div class="col px-3 node-name">
							<div class="node-name-text">
								<span v-html="display(item)"></span>
								<span v-if="item.isLocked" class="is-locked">
									<icon icon="lock" />
								</span>
							</div>
						</div>
						<div class="col-auto node-buttons" v-if="settings.editable">
							<div class="d-sm-none">
								<div class="icon buttons-list" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<icon :icon="['fas', 'ellipsis-v']" />
									<div class="dropdown-menu">
										<button class="dropdown-item" v-if="settings.onNodeDeleteClicked && typeof settings.onNodeDeleteClicked === 'function' && !item.hasChild" :disabled="!$nikan.checkPermission(settings.deletePolicyClaims)" @click="settings.onNodeDeleteClicked(item)" :title="$t('delete')">
											{{ $t('delete') }}
										</button>
										<button v-if="settings.onNodeAddClicked && typeof settings.onNodeAddClicked === 'function'" :disabled="!$nikan.checkPermission(settings.addPolicyClaims)" class="dropdown-item" @click="settings.onNodeAddClicked(item)" :title="$t('insert')">
											{{ $t('insert') }}
										</button>
										<button class="dropdown-item" @click="settings.onNodeEditClicked(item)" v-if="settings.onNodeEditClicked && typeof settings.onNodeEditClicked === 'function'" :disabled="!$nikan.checkPermission(settings.editPolicyClaims)" :title="$t('edit')">
											{{ $t('edit') }}
										</button>
										<div class="d-inline" v-for="b in buttonsWithPermission" :key="b.id">
											<button v-if="(!b.treeCondition) || (b.treeCondition && b.treeCondition(item))" class="dropdown-item" @click="b.handler(item)" :title="b.title">
												{{ b.title }}
											</button>
										</div>
									</div>
								</div>
							</div>
							<button class="icon delete d-none d-sm-inline-block" v-if="settings.onNodeDeleteClicked && typeof settings.onNodeDeleteClicked === 'function' && !item.hasChild" @click="settings.onNodeDeleteClicked(item)" :disabled="!$nikan.checkPermission(settings.deletePolicyClaims)" :title="$t('delete') + ' ' + '(Ctrl + Delete)'">
								<icon :icon="['fas', 'trash']" />
							</button>
							<button class="icon add d-none d-sm-inline-block" v-if="settings.onNodeAddClicked && typeof settings.onNodeAddClicked === 'function'" :disabled="!$nikan.checkPermission(settings.addPolicyClaims)" @click="settings.onNodeAddClicked(item)" :title="$t('insert') + ' ' + '(Ctrl + Insert)'">
								<icon :icon="['fas', 'plus-circle']" />
							</button>
							<button class="icon edit d-none d-sm-inline-block" v-if="settings.onNodeEditClicked && typeof settings.onNodeEditClicked === 'function'" :disabled="!$nikan.checkPermission(settings.editPolicyClaims)" @click="settings.onNodeEditClicked(item)" :title="$t('edit') + ' ' + '(Ctrl + Insert)'">
								<icon :icon="['fas', 'edit']" />
							</button>
							<div class="d-inline" v-for="b in buttonsWithPermission" :key="b.id">
								<button v-if="(!b.treeCondition) || (b.treeCondition && b.treeCondition(item))" :class="['d-none d-sm-inline-block icon', b.theme]" @click="b.handler(item)" :title="b.title">
									<icon :icon="b.icon" />
								</button>
							</div>
						</div>
					</div>
					<nk-sub-tree v-if="item.hasChild && expands.includes(item.id)" :height="height" :data="data" :expands="filterExtends" :parentId="item.id" :settings="settings" :selected="selected" @nodeSelected="n => $emit('nodeSelected', n)" @nodeStateChanged="n => $emit('nodeStateChanged', n)" @nodeDblClicked="n => onNodeDblClick(n)"></nk-sub-tree>
				</li>
			</template>
		</nk-virtual-scroller>
		<li v-if="nodes.length === 0 && parent && expands.includes(parent.id)" class="shadow-node">
			<div class="node-line"></div>
			<div class="row no-gutters tree-group-item">
				<div class="col-auto px-0 node-ver-line"></div>
				<div class="col-auto px-0 node-icon">
					<div class="icon">
						<i class="expand-icon"></i>
					</div>
				</div>
				<div class="col px-3 node-name">
					<div class="node-name-text">
						<span>{{ $t('msg.has-child-other-fiscal') }}</span>
						<span class="is-locked">
							<icon icon="lock" />
						</span>
					</div>
				</div>
			</div>
		</li>
	</ul>

</template>
<script>
	import _ from 'lodash'
	export default {
		props: {
			data: { type: Array, default: () => ([]) },
			parentId: { type: String },
			height: { type: Number },
			settings: { type: Object },
			selected: { type: Object },
			expands: { type: Array, default: [] },
		},
		emits: ['nodeDblClicked', 'nodeSelected', 'nodeStateChanged'],
		mounted() {
		},
		watch: {
			data: {
				deep: true,
				handler(val) {
					const calcChild = (nodes) => {
						let count = 0
						nodes.forEach(vNode => {
							if (vNode.hasChild) {
								count += calcChild(this.data.filter(x => x?.parent?.id === vNode.id))
							}
							count++

						})
						return count
					}
					const childLength = calcChild(this.nodes)
					// console.log('childLength',childLength)
					// console.log('data',this.data.length)
					// console.log('height',this.height)
					if (!this.parentId) this.localHeight = this.height
					else if (childLength * 40 < this.height) this.localHeight = this.height * 2
					else if (childLength < 100) {
						this.localHeight = childLength * 40 * 1.5
					} else this.localHeight = this.height
					// console.log('localhaight',this.localHeight)
				}
			},
		},
		data() {
			return {
				randomId: Math.ceil(Math.random() * 1000),
				localHeight: 0,
				configs: {
					filterType: 0,
					selectedChild: 'selected',
					searchText: '',
					searchMode: false,
					foundNodesNumber: 0,

					expandLevel: 0,
				},
			}
		},
		computed: {
			parent() {
				return _.head(this.data.filter((x) => x.id === this.parentId))
			},
			buttonsWithPermission() {
				let filtered = this.settings.buttons.filter(x => this.$nikan.checkPermission(x.policyClaims))
				filtered.map(x => x.id = this.idGenerator(5))
				return filtered
			},
			nodes() {
				let arr

				if (this.parentId != null)
					arr = this.data.filter((x) => x.parent && x.parent.id === this.parentId)
				else
					arr = this.data.filter((x) => x.parent == null)

				for (let a of arr) {
					this.cssClass(a)
				}

				return arr
			},
			visibleNodes() {
				return this.nodes.filter(x => x.parent === null || this.expands.includes(x.parent.id))
			},
			filterExtends(id) {
				// console.log('visibleNodes',this.visibleNodes)
				let temp = this.expands.filter(x => this.visibleNodes.some(node => node?.parent?.id !== x))
				// console.log('temp',temp)
				return temp
			},
		},
		methods: {
			onNodeDblClick(node) {
				this.$emit('nodeDblClicked', node)
			},
			getChildren(parentId) {
				return this.data.filter((x) => x.parent && x.parent.id === parentId)
			},
			onNodeClick(node) {
				this.$emit('nodeSelected', node)
			},
			onNodeStateChangeClicked(e, node) {
				e.stopPropagation()

				this.$emit('nodeStateChanged', node)
			},
			cssClass(node) {
				let arr = []
				if (Array.isArray(node.cssClass)) {
					if (this.expands.includes(node.id)) arr.push('expanded')
					else node.cssClass = node.cssClass.filter(x => x !== 'expanded')
					if (node.hasChild) !node.cssClass.includes('has-child') && arr.push('has-child')
					else node.cssClass = node.cssClass.filter(x => x !== 'has-child')
					if (this.selected && this.selected.id === node.id) arr.push('selected')
					else node.cssClass = node.cssClass.filter(x => x !== 'selected')
					// if (node.cssClass.some(x => this.settings.nodeCustomClass?.some(y => y === x)))

					node.cssClass = [...node.cssClass, ...arr]
				}
				else {
					if (this.expands.includes(node.id)) arr.push('expanded')
					if (node.hasChild) arr.push('has-child')
					if (this.selected && this.selected.id === node.id) arr.push('selected')
					node.cssClass = arr

				}
			},
			display(node) {
				if (this.settings.display && _.isFunction(this.settings.display)) {
					return this.settings.display(node)
				}
				return node.name
			},
		},
	}
</script>
<style>
	.button-list {
		color: #aaa;
		background-color: white;
	}

	div.vue-recycle-scroller__item-wrapper>div.vue-recycle-scroller__item-view:last-child {
		content: "";
		display: block;
		position: absolute;
		top: 0px;
		right: -0px;
		width: 1px;
		background: linear-gradient(to bottom, transparent 20px, white 20px)
	}

	/*li:last-child::before {*/
	/*	display: none;*/
	/*}*/
</style>
